export function PopupOpenWebPayViewStyle() {
  return (
    <style>{`
      .view {
        display: flex;
        position: absolute;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        z-index: 1000;
      }

      .popup {
        display: flex;
        position: absolute;
        width: 36rem;
        max-height: 100svh;
        max-width: 100vw;
        padding: 1rem;
        flex-direction: column;
        align-items: center;
        justify-content: stretch;
        border-radius: 30px;
        background: #fff;
        animation: scale-up 0.2s ease;
      }

      .popupMobile {
        display: flex;
        position: absolute;
        bottom: 0;
        width: 100%;
        max-height: 100svh;
        padding: 1rem;
        flex-direction: column;
        align-items: center;
        justify-content: stretch;
        border-radius: 20px 20px 0px 0px;
        background: #fff;
        animation: slide-up 0.2s ease;
      }

      @keyframes slide-up {
        from {
          transform: translateY(100%);
        }
        to {
          transform: translateY(0%);
        }
      }

      @keyframes slide-right {
        from {
          transform: translateX(100%);
        }
        to {
          transform: translateX(0%);
        }
      }

      @keyframes slide-left {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      @keyframes scale-up {
        from {
          transform: scale(0);
        }
        to {
          transform: scale(1);
        }
      }

      @keyframes fade-in {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

      .details {
        display: flex;
        padding: 1rem 0px 1rem 0px;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        align-self: stretch;
      }

      .price {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
      }


      .currencySymbol {
        color: #242424;
        font-family: Helvetica;
        font-size: 2rem;
        font-style: normal;
        font-weight: 700;
        line-height: 2rem;
      }

      .amount {
        color: #242424;
        font-family: Helvetica;
        font-size: 3rem;
        font-style: normal;
        font-weight: 700;
        line-height: 2.5rem;
      }

      .currency {
        color: #242424;
        font-family: Helvetica;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
      }

      .description {
        display: flex;
        flex-direction: row;
        color: #6b6b6b;
        text-align: center;
        font-family: Helvetica;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .secure {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        align-self: stretch;
        color: #6b6b6b;
        text-align: center;
        font-family: Helvetica;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-bottom: 1rem;
      }

      .back {
        display: flex;
        position: absolute;
        top: 1.5rem;
        left: 1.5rem;
        width: 1.5rem;
        height: 1.5rem;
        justify-content: center;
        align-items: center;
      }

      .close {
        display: flex;
        position: absolute;
        top: 1.5rem;
        right: 1.5rem;
        width: 1.5rem;
        height: 1.5rem;
        justify-content: center;
        align-items: center;
      }

      .divider {
        width: 100%;
        height: 1px;
        background: #dadada;
      }

      .paymentMethods {
        display: flex;
        min-height: 60svh;
        align-items: flex-start;
        align-content: flex-start;
        justify-content: center;
        gap: 0.5rem;
        flex: 1 0 0;
        align-self: stretch;
        flex-wrap: wrap;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: #dadada #f8f8f8;
      }

      .paymentMethod {
        display: flex;
        width: 6rem;
        height: 7rem;
        padding: 0.5rem;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        gap: 2px;
        border-radius: 14px;
        background: #f8f8f8;
      }

      .paymentMethodLogo {
        display: flex;
        width: 5rem;
        justify-content: center;
        align-items: center;
        user-drag: none; 
        user-select: none;
        -moz-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        -ms-user-select: none;
      }

      .paymentMethodLogo img {
        user-drag: none; 
        user-select: none;
        -moz-user-select: none;
        -webkit-user-drag: none;
        -webkit-user-select: none;
        -ms-user-select: none;
      }

      .paymentMethodName {
        display: flex;
        color: #242424;
        text-align: center;
        font-family: Helvetica;
        font-size: 0.8rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
                line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .paymentLogo {
        display: flex;
        justify-content: center;
        padding-bottom: 1rem;
        align-items: center;
        gap: 0.5rem;
        align-self: stretch;
        color: #6B6B6B;
        text-align: center;
        font-family: Helvetica;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .paymentLogo img {
        width: auto;
        max-width:5rem;
        height: 2rem;
      }

      .encrypted {
        display: flex;
        padding-bottom: 1rem;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        align-self: stretch;
        color: #6B6B6B;
        text-align: center;
        font-family: Helvetica;
        font-size: 0.8rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .paymentForm {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
        align-self: stretch;
        color: #6B6B6B;
        text-align: center;
        font-family: Helvetica;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .payButtonArea {
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: stretch;
        width: 100%;
      }

      .payButton {
        width: 18.5rem;
        height: 3.6rem;
        border-radius: 6rem;
        background: linear-gradient(0deg, #171717 0%, #171717 100%), #FFF;
        color: #FFF;
        text-align: center;
        font-family: Helvetica;
        font-size: 1.5rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border: 2px;
      }

      .payButton:disabled {
        background: #b7b7b7;
      }

      .payButton.rakutenPay {
        background: url(https://checkout.rakuten.co.jp/p/common/img/btn_check_00.gif);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        border-radius: 0;
        width: 70%;
      }

      .payButton.rakutenPay:disabled {
        opacity: 0.3;
      }

      .ageConsentContainer {
        display: flex;
        padding-top: 0.5rem;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        align-self: stretch;
        color: #6B6B6B;
        text-align: left;
        font-family: Helvetica;
        font-size: 0.7rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }


    .lds-ring,
    .lds-ring div {
      box-sizing: border-box;
    }
    .lds-ring {
      display: inline-block;
      position: relative;
      width: 3rem;
      height: 3rem;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      width: 2rem;
      height: 2rem;
      margin: 0.25rem;
      border:  0.25rem solid currentColor;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: currentColor transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    .cancelPayment {
      display: flex;
      position: absolute;
      min-width: 10rem;
      max-width: 30rem;
      height: 16rem;
      padding: 1rem;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;
      background: #ffffff;
      border-radius: 30px;
      animation: scale-up 0.2s ease;
    }

    .cancelPaymentHeader {
      display: flex;
      padding: 1rem 1rem 0px 1rem;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 1.5rem;
      flex: 1 0 0;
      align-self: stretch;
      color: #6B6B6B;
      text-align: center;
      font-family: Helvetica;
      font-size: 1rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
    }

    .cancelPaymentButtons {
      display: flex;
      padding-bottom: 0.5rem;
      justify-content: center;
      align-items: flex-end;
      gap: 1rem;
      flex: 1 0 0;
      align-self: stretch;
    }

    .button {
        padding: 1rem 1rem;
        border-radius: 6rem;
        flex: 1 0 0;
        text-align: center;
        font-family: Helvetica;
        font-size: 1rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border: 2px;
        background:#ffffff;
        color: #6B6B6B;
        border: 2px solid #6B6B6B;
      }

      .black {
        color: #FFF;
        background: #171717;
        border: 2px solid #171717;
      }

      .overlay {
        display: flex;
        position: fixed;
        width: 100vw;
        height: 100svh;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.5);
        justify-content: center;
        align-items: center;
        animation: fade-in 0.2s ease;
      }

      .hidden {
        display: none;
      }

      .helpHeader{
        display: flex;
        padding: 0px 1rem 1rem 1rem;
        flex-direction: column;
        align-items: center;
        gap: 1.5rem;
        align-self: stretch;
        color: #242424;
        text-align: center;
        font-family: Helvetica;
        font-size: 1.3rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      .spacerTop {
        display: flex;
        height: 20svh;
        flex-shrink: 1;
      }

      .spacerBottom {
        display: flex;
        height: 20svh;
        flex-shrink: 1;
      }

      .paymentContent {
        display: flex;
        flex-direction: column;
        min-height: 60svh;
        max-height: 77svh;
        align-items: center;
        justify-content: stretch;
        overflow-y: auto;
        width: 100%;
      }

      .chooseDifferentMethod {
        width: 100%;
        text-align: center;
        color: #6B6B6B;
        padding-top: 1rem;
        padding-bottom: 1rem;
      }

      .moreButton {
        width: 19rem;
        height: 3rem;
        border-radius: 6rem;
        text-align: center;
        font-family: Helvetica;
        font-size: 1.25rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        background:#ffffff;
        color: #6B6B6B;
        border: 2px solid #6B6B6B;
        margin-top: 0.5rem;
        highlight:none;
      }

    `}</style>
  );
}
